<template>
	<div>
		<h1 v-if="node_workflow && node_workflow.description">{{node_workflow.description}}</h1>

		<p v-if="node_workflow && node_workflow.long_description">{{ node_workflow.long_description }}</p>

		<b-tabs v-model="tab">

			<b-tab title="Créaction d'un traitement" v-if="!workflow">
				<br />
				<create @launch="follow_treatment" :minimal="true" v-if="mode == 'create'" :default_project="project"></create>
			</b-tab>
			<b-tab title="Récupération d'un traitement">
				<br />
				<treatments_list ref="treatments_list" @treatment="set_treatment" :size="10" :minimal="true" v-if="mode == 'create'" :default_project="project" />
			</b-tab>
			<b-tab title="Traitement">
				<br />
				<treatment @set_description_node="set_description_node" @add_project_workflow="add_project_workflow" :list_projects="list_projects" :workflow="workflow" @treatment="follow_treatment_uid" :minimal="true" v-show="treatment_uid" ref="treatment" @set_data_in="set_data_in"></treatment>
				<div v-show="!treatment_uid">Pas de traitement sélectionné</div>
			</b-tab>
		</b-tabs>

		<br />

		<div v-if="treatments.length > 0">
			<p><b>Traitements en cours</b></p>

			<div v-for="(treatment, idx) in treatments" :key="'treatment_' + idx">
				Traitement {{treatment.uid}} - projet {{list_obj_projects_uid[treatment.projet_uid]}}
			</div>

			<br />
		</div>

		<div v-if="finish_treatments.length > 0">
			<p><b>Traitements terminés</b></p>

			<div v-for="(treatment, idx) in finish_treatments" :key="'finish_treatment_' + idx">
				Traitement {{treatment.uid}} - projet {{list_obj_projects_uid[treatment.projet_uid]}}{{(treatment.resultat == "ok" || treatment.resultat == "ko") ? " - " + treatment.resultat : ""}}
			</div>

			<br />
		</div>

		<div v-show="false && data.length > 0">
			<p>Données envoyées en validation</p>
			<edit_tabulator @update="change_tabulator" ref="tabulator" :extern_file="false"></edit_tabulator>
		</div>
		
		<hr />
	</div>
</template>

<script>
	var clone = require("clone");

	import uniqueId from "lodash.uniqueid";

	import store from "../store";
	import create from "../views/Create.vue";
	import users from "../services/users.js";
	import client from "../services/client.js";
	import library from "../services/library.js";
	import projects from "../services/projects.js";
	import treatments from "../services/treatments.js";
	import treatment from "../components/treatment.vue";
	import treatments_list from "../views/Treatments.vue";
	import edit_tabulator from "../components/edit_tabulator.vue";

	export default {
		name: "treatment_selector",
		components: {
			create,
			edit_tabulator,
			treatments_list,
			treatment
		},
		props: {
			node_workflow: {
				default: () =>  null
			},
			worflow_builder: {
				default: false
			},
			minimal: {
				default: false
			},
			p_project: {

			},
			workflow: {
				default: false
			}
		},
		watch: {
		},
		data() {
			return {
				id: uniqueId(),
				project: "",
				mode: "create",

				tab: 0,

				treatments: [],
				finish_treatments: [],

				list_obj_projects_uid: {},
				data: [],
				treatment_uid: "",
				list_projects: []
			};
		},
		methods: {
			set_description_node(id, description)
			{
				this.$emit("set_description_node", this.workflow, description)
			},
			set_data_in()
			{
				this.$emit("set_data_in", this.workflow);
			},
			add_project_workflow(workflow, project_uid)
			{
				this.$emit("add_project_workflow", this.workflow, project_uid);
			},
            async get_data_out()
            {
				if (this.treatment_uid)
				{
					return await this.$refs.treatment.get_data_out();
				}
				else
				{
					return [];
				}
			},
			get_data()
			{
				return this.$refs.tabulator.get_data();
			},
			async change_tabulator(data)
			{
				this.$emit("add", data);
			},
			async set_treatment(uid)
			{
				this.treatment_uid = uid;
				this.$refs.treatment.start(uid);
				this.tab = 2;
			},
			async finish_treatment(treatment)
			{
				if (treatment.details.sub_treatment && treatment.details.sub_treatment_arr)
				{
					//console.log("sub_treatment")
					for (var i = 0; i < treatment.details.sub_treatment_arr.length; i++)
					{
						this.follow_treatment_uid(treatment.details.sub_treatment_arr[i]);
					}
				}
				else if (treatment.resultat == 'ok')
				{
					//console.log("finish treatment")
					var all_files = await treatments.getFiles(
						treatment.uid
					);
					var export_type = "export";
					var csv = [];
					for (var j = 0; j < all_files.length; j++) 
					{
						if (all_files[j].type == export_type && all_files[j].nom_fichier.endsWith(".csv")) 
						{
							var csv_data = await treatments.getFile(
								all_files[j].uid,
								all_files[j].nom_fichier,
								false,
								false
							);
							var name_file = all_files[j].nom_fichier;
							var results = this.$papa.parse(csv_data, {
								header: true,
							});
							this.data = results.data;
							this.$emit("add", true, this.data);
							//this.$refs.tabulator.set_data(this.data);

							break;
						}
					}
				}
			},
			async verify_treatments()
			{
				for (var i = 0; i < this.treatments.length; i++)
				{
					var treatment = clone(this.treatments[i]);

					var treatment = await treatments.get(treatment.uid);
					treatment = treatment.treatment

					if (treatment.resultat == "ok" || treatment.resultat == "ko" || (treatment.details.sub_treatment && treatment.details.sub_treatment_arr))
					{
						this.treatments.splice(i, 1);
						this.finish_treatments.push(treatment);
						i--;

						await this.finish_treatment(treatment);
					}
				}
			},
			async follow_treatment_uid(uid)
			{
				var treatment = await treatments.get(uid);
				treatment = treatment.treatment
				this.tab = 1;
				
				if (treatment.resultat == "ok" || treatment.resultat == "ko" || (treatment.details.sub_treatment && treatment.details.sub_treatment_arr))
				{
					//console.log("finish: " + treatment.uid)
					await this.finish_treatment(treatment);
				}
				else
				{
					//console.log("wait: " + treatment.uid)
					this.treatments.push(treatment)
				}
			},
			async follow_treatment(treatment)
			{
				//console.log("follow: " + treatment.uid)
				var treatment = await treatments.get(treatment.uid);
				treatment = treatment.treatment;

				if (treatment.resultat == "ok" || treatment.resultat == "ko" || (treatment.details.sub_treatment && treatment.details.sub_treatment_arr))
				{
					//console.log("finish: " + treatment.uid)
					await this.finish_treatment(treatment);
				}
				else
				{
					//console.log("wait: " + treatment.uid)
					this.treatments.push(treatment)
				}
			},
			async save()
			{
			},
			async load(data, name)
			{
				//console.log("load");

				if (typeof data == "string")
					data = JSON.parse(data);

				if (data.project)
					this.project = data.project;
			},
			async save_workflow()
			{
				var data = {
					project: this.$refs.treatments_list.get_project()
				};

				return data;
			},
			async load_workflow(data)
			{
			},
		},
		mounted: async function () {
			
			var self = this;

			if (this.p_project)
			{
				this.project = this.p_project;
			}

			this.list_projects = await projects.getAll(false, false, null, true);

			this.list_obj_projects_uid = {};

			for (var i = 0; i < this.list_projects.length; i++) 
			{
				this.list_obj_projects_uid[this.list_projects[i].uid] = this.list_projects[i].libelle;
			}

			this.timer = setInterval(() => {
				this.verify_treatments()
			}, 15000)
		},
	};
</script>
